<template>
  <div class="page-container">
    <!-- Content Wrapper START -->
    <div class="main-content">
      <pageheader
        :page-name="pageName"
        parent-page-name="Images"
        :parent-page-url="`/products/${this.$route.params.parent_id}/images`"
      />
      <add-edit-form
        v-if="model"
        :returnUrl="`/products/${this.$route.params.parent_id}/images`"
        :apiBaseUrl="API_BASE_URL"
        :model="model"
        :fields="fields"
        :toEdit="toEdit"
      />
    </div>
    <!-- Content Wrapper END -->
  </div>
</template>

<script>
import Pageheader from '@/components/Pageheader.vue'
import AddEditForm from '@/components/AddEditForm.vue'
import Image from '@/models/Image'
/* eslint-disable no-undef */
export default {
  name: 'AddImage',
  components: {
    Pageheader,
    AddEditForm
  },
  computed: {
    toEdit () {
      return this.$route.params.id !== undefined
    },
    pageName () {
      return this.toEdit ? 'Edit Image' : 'Add Image'
    }
  },
  data () {
    return {
      API_BASE_URL: 'image',
      model: null,
      fields: [
        { label: 'Name', key: 'name', type: 'text' },
        { label: 'Sort number', key: 'sort_no', type: 'number' },
        { label: 'PSD Format', key: 'PSD', type: 'format' },
        { label: 'PDF Format', key: 'PDF', type: 'format' },
        { label: 'PNG Format', key: 'PNG', type: 'format' },
        { label: 'XLS Format', key: 'XLS', type: 'format' },
        { label: 'JPG Format', key: 'JPG', type: 'format' },
        { label: 'Word Format', key: 'WORD_DOC', type: 'format' },
        { label: 'AI Format', key: 'AI', type: 'format' },
        { label: 'All Formats', key: 'ALL', type: 'format' },
        { label: 'EPS Format', key: 'EPS', type: 'format' }
      ]
    }
  },
  mounted () {
    if (this.toEdit) {
      this.fetch()
    } else {
      this.model = new Image()
      this.model.product_id = this.$route.params.parent_id
    }
  },
  methods: {
    fetch () {
      this.$store.dispatch(this.API_BASE_URL + '/get', this.$route.params.id)
        .then((result) => {
          this.model = new Image(result.image)
        })
        .catch((err) => this.$helper.catchHandler(err))
      return null
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Products/Images/AddEdit.vue